import { allTrackers } from "app/services/track/track";

const POPUP_CATEGORY = "popup";
const EVENT_NAME = "Extension/Land on Pro";

export const trackSecondLandExtensionShow = (): void => {
    allTrackers.dispatchTrackEvent(POPUP_CATEGORY, "Show", EVENT_NAME);
};

export const trackSecondLandExtensionClick = (): void => {
    allTrackers.dispatchTrackEvent(POPUP_CATEGORY, "Click", EVENT_NAME);
};

export const trackSecondLandExtensionClose = (): void => {
    allTrackers.dispatchTrackEvent(POPUP_CATEGORY, "Close", EVENT_NAME);
};
